import { render, staticRenderFns } from "./EndOfExerciseNew.vue?vue&type=template&id=1de7527c"
import script from "./EndOfExerciseNew.vue?vue&type=script&lang=js"
export * from "./EndOfExerciseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports